import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLine } from "./Reveal";
import { IMAGES, BUSINESS } from "@/lib/content";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.12]);
  const fade = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  return (
    <section id="top" ref={ref} data-testid="hero" className="relative min-h-screen w-full overflow-hidden">
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <img src={IMAGES.hero} alt="Bespoke living room by Simpliq Atelier" className="img-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/45 via-transparent to-[#FBF9F6]/10" />
      </motion.div>

      <motion.div style={{ opacity: fade }} className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-12 min-h-screen flex flex-col justify-end pb-20 md:pb-28">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="eyebrow text-[#FBF9F6]/90 mb-6"
        >
          Handmade custom furniture · Est. Vaughan, Ontario
        </motion.div>

        <h1 className="font-serif text-white leading-[0.95] tracking-tight text-5xl sm:text-7xl lg:text-[8.5rem]">
          <MaskLine delay={0.35}>Furniture made</MaskLine>
          <MaskLine delay={0.5}>the way it should</MaskLine>
          <MaskLine delay={0.65}><span className="italic text-[#E7DFD4]">be made — by hand.</span></MaskLine>
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 0.9 }}
          className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-6 md:gap-10"
        >
          <p className="text-[#FBF9F6]/85 max-w-md text-base leading-relaxed">
            Bespoke pieces for discerning homes and businesses. Designed with you, built to last generations.
          </p>
          <button
            data-testid="hero-cta"
            onClick={() => scrollTo("contact")}
            className="bg-[#FBF9F6] text-[#1A1A1A] px-8 py-4 rounded-full text-sm tracking-wide hover:bg-[#8C7A6B] hover:text-white transition-colors duration-500 whitespace-nowrap"
          >
            Begin your commission
          </button>
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.4 }}
        className="absolute bottom-8 right-6 md:right-12 z-10 text-[#FBF9F6]/70 text-xs tracking-widest hidden md:block"
      >
        {BUSINESS.address}
      </motion.div>
    </section>
  );
};
